module.exports = __webpack_public_path__ + "media/access/analytics-e1ccbae0.png";